import findIndex from 'lodash/findIndex';
import isEqual from 'lodash/isEqual';

import PromotionsCollection from './collection';
import PromotionModel from './model';
import PaginatableCollection from 'domains/base/store/collection';

export const state = {
  promotionsCollection: new PromotionsCollection(),
  currentPromotion: {},
  formIsDirty: false,
};

export const mutations = {
  setPromotions(state, response) {
    state.promotionsCollection.promotions = [...state.promotionsCollection.promotions, ...response.data._embedded.items]
    state.promotionsCollection.initialized = true;
    state.promotionsCollection.total = response.data.total_results;

    if (response.data._embedded.items.length === state.promotionsCollection.limit) {
      state.promotionsCollection.page++;
      state.promotionsCollection.canLoad = true;
    } else {
      state.promotionsCollection.canLoad = false;
    }
  },

  setPromotionsCampaignId(state, campaignId) {
    if (state.promotionsCollection.campaignId !== campaignId) {
      state.promotionsCollection.campaignId = campaignId;
      mutations.resetPromotions(state);
    }
  },

  searchPromotions(state, query) {
    state.promotionsCollection.query = query;
  },

  sortPromotions(state, sortColumn) {
    state.promotionsCollection.sortDirection = state.promotionsCollection.sortColumn === sortColumn && !state.promotionsCollection.sortDirection ? 1 : 0;
    state.promotionsCollection.sortColumn = sortColumn;
  },

  resetPromotions(state) {
    state.promotionsCollection.promotions = [];
    state.promotionsCollection.page = 0;
    state.promotionsCollection.canLoad = true;
    state.promotionsCollection.initialized = false;
    state.promotionsCollection.total = 0;
    state.formIsDirty = false;
  },

  setCurrentPromotion(state, promotionData) {
    promotionData.expiration_date = promotionData.expiration_date.split('T')[0];
    state.currentPromotion = promotionData;
    state.currentPromotion.activated = state.currentPromotion.activated ? true : false;
    state.formIsDirty = false;
  },

  updateCurrentPromotion(state, { prop, value, original }) {
    state.currentPromotion[prop] = value;

    if (isEqual(state.currentPromotion, original)) {
      state.formIsDirty = false;
    } else {
      state.formIsDirty = true;
    }
  },

  createPromotion(state, campaignId) {
    state.currentPromotion = new PromotionModel(campaignId);
    state.formIsDirty = false;
  },

  activatePromotion(state, { promotion, activated }) {
    promotion.activated = activated;
  },

  removePromotion(state, promotion) {
    state.promotionsCollection.promotions.splice(findIndex(state.promotionsCollection.promotions, promo => promo.id === promotion.id), 1);
    state.promotionsCollection.total--;
  },
};